<template>
  <layout-main-inner
    showBack
    :title="$route.query.msgId ? '编辑解决方案':'新增解决方案'">
    <div slot="action">
      <!-- <el-button
        type="warning"
        @click="editMessage(0)">暂存</el-button> -->
      <el-button
        type="primary"
        @click="editMessage(1)">完成</el-button>
    </div>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <el-form
        ref="ruleForm"
        style="max-width: 720px;margin: 0 auto;"
        :model="info"
        :rules="rules"
        label-width="120px">
        <!-- <el-row :gutter="20">
          <el-col :span="8"> -->
        <el-form-item
          label="解决方案标题："
          prop="title">
          <el-input v-model="info.title"></el-input>
        </el-form-item>
        <el-form-item
          label="首图："
          prop="image">
          <upload-with-crop
            v-model="info.image"
            :isLt2M="500"
            :fixedNumber="[1,1]"
            :autoCropWidth="120"
            :autoCropHeight="120"></upload-with-crop>
        </el-form-item>
        <!-- </el-col> -->
        <!-- <el-col :span="8">
            <el-form-item
              label="解决方案类型："
              prop="contentType">
              <el-radio-group
                v-model="info.contentType"
                :disabled="!!$route.query.msgId"
                @change="handleChange">
                <el-radio-button :label="0">多图</el-radio-button>
                <el-radio-button :label="1">公众号链接</el-radio-button>
                <el-radio-button :label="6">视频素材</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8"> -->
        <el-form-item
          label="解决方案简介："
          prop="content.brief">
          <el-input
            v-model="info.content.brief"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式："
          prop="content.contactInfo">
          <el-input
            v-model="info.content.contactInfo"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
        <!-- </el-col> -->
        <!-- </el-row> -->
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item
              label="首图："
              prop="image">
              <upload-with-crop
                v-model="info.image"
                :cropper="true"
                :fixedNumber="[5,3]"
                :autoCropWidth="300"
                :autoCropHeight="180" />
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row
          v-if="info.contentType===0">
          <el-col :span="12"> -->

        <el-form-item
          label="图片详情："
          prop="content.images">
          <desc-images
            v-model="info.content.images"
            :edit="true"></desc-images>
        </el-form-item>
        <!-- </el-col>
        </el-row> -->
        <!-- <el-row
          v-if="info.contentType===1">
          <el-col :span="8">
            <el-form-item
              label="公众号文章链接："
              prop="content">
              <el-input v-model="info.content"></el-input>
              <span>例如：https://mp.weixin.qq.com/xx</span>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <template v-if="info.contentType === 6">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="视频详情："
                prop="content">
                <desc-images
                  v-model="info.content"
                  :limit="1"
                  accept=".mp4"
                  :edit="true"
                  @fileuploaded="fileuploaded"></desc-images>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="封面预览："
                prop="imageSrc">
                <img
                  style="width: 375px;"
                  :src="info.imageSrc"
                  alt="">
              </el-form-item>
            </el-col>
          </el-row>
        </template> -->
        <!-- <el-row
          v-if="info.contentType === 3">
          <el-col :span="24">
            <el-form-item
              label="商品信息："
              prop="content">
              <el-button
                type="primary"
                @click="selectProd">选择商品</el-button>
              <div v-if="goodsInfo.goodsName || goodsInfo.goodsFullname">{{ goodsInfo.goodsName || goodsInfo.goodsFullname }}</div>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </layout-card-wrap>
    <!-- <goods-select-modal
      ref="modal"
      :callback="formatSelected" /> -->
  </layout-main-inner>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
// import UploadWithCrop from '@/components/wx/upload-with-crop.vue'
// import GoodsSelectModal from './busi/goods-select-modal.vue'
// import _ from 'lodash'
export default {
  name: 'WxappMessageEdit',
  components: {
    DescImages,
    UploadWithCrop
    // GoodsSelectModal
  },
  data() {
    return {
      // init: true,
      info: { title: '', name: '', image: [], contentType: 100, content: { brief: '', images: [], contactInfo: '' }},
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'change' }
        ],
        'content.brief': [
          { required: true, message: '请输入解决方案简介', trigger: 'change' },
          { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'change' }
        ],
        // image: [
        //   { required: true, message: '请录入首图', trigger: 'change' }
        // ],
        'content.contactInfo': [
          { required: true, message: '请选择解决方案类型', trigger: 'change' }
        ],
        image: [
          { required: true, message: '请上传首图', trigger: 'change' }
        ],
        'content.images': [
          { required: true, message: '请上传图片详情', trigger: 'change' }
        ]
      }
    }
  },
  // computed: {
  //   goodsInfo() {
  //     return this.info.contentType === 3 ? JSON.parse(this.info.content || '{}') : {}
  //   }
  // },
  // watch: {
  //   'info.contentType'(val) {
  //     // if (!this.init) {
  //     //   return
  //     // }
  //     if (val === 0) {
  //       this.info.content = []
  //     } else if (val === 4) {
  //       this.info.content = []
  //     } else {
  //       this.info.content = ''
  //     }
  //   }
  // },
  mounted() {
    if (this.$route.query.msgId) {
      this.getmessage()
    }
  },
  methods: {
    // handleChange(val) {
    //   console.log('.handleChange')
    //   if (val === 0) {
    //     this.info.content = []
    //   } else if (val === 4) {
    //     this.info.content = []
    //   } else {
    //     this.info.content = ''
    //   }
    // },
    // getVideoPoster(url) {
    //   return new Promise((resolve) => {
    //     const video = document.createElement('video')
    //     video.setAttribute('crossorigin', 'anonymous') // 处理跨域
    //     video.setAttribute('src', url)
    //     video.setAttribute('controls', 'controls')
    //     video.currentTime = 8 // 视频时长，一定要设置，不然大概率白屏
    //     video.addEventListener('loadeddata', () => {
    //       video.setAttribute('width', video.videoWidth)
    //       video.setAttribute('height', video.videoHeight)
    //       const canvas = document.createElement('canvas')
    //       canvas.width = video.width
    //       canvas.height = video.height
    //       canvas.getContext('2d').drawImage(video, 0, 0, video.width, video.height) // 绘制canvas
    //       resolve(canvas.toDataURL('image/png'))
    //     })
    //   })
    // },
    // fileuploaded(file) {
    //   console.log(file)
    //   // this.getVideoPoster(URL.createObjectURL(file))
    //   //   .then((imageSrc) => {
    //   //     this.info.imageSrc = imageSrc
    //   //   })
    // },
    // selectProd() {
    //   this.$refs.modal.fetch()
    // },
    // formatSelected(data) {
    //   data = _.cloneDeep(data)
    //   this.info.content = JSON.stringify(data)
    // },
    getmessage() {
      this.loading = true
      this.$store.dispatch('portal/getmessage', {
        payload: { vendorId: this.$route.query.vendorId, msgId: this.$route.query.msgId },
        success: res => {
          this.loading = false
          // this.init = false
          const { image, content } = res.data
          const { brief, images, contactInfo } = JSON.parse(content)
          this.info = {
            ...res.data,
            image: image.split(',').map(item => ({ url: item, name: item })),
            content: { brief, images: this.$splitImage(images), contactInfo }
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    editMessage(status) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.$route.query.msgId ? 'updatemessage' : 'addmessage'
          const { image, content } = this.info
          const { brief, images, contactInfo } = content
          this.$store.dispatch(`portal/${dispatch}`, {
            payload: {
              ...this.$route.query,
              ...this.info,
              image: image.map(item => item.url).join(','),
              content: JSON.stringify({ brief, images: images.map(item => item.url).join(','), contactInfo }),
              isShowImage: 1,
              status
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
